import { createContext, useContext, useState } from "react";
import {
  clearQuizStateFromWindow,
  createDefaultQuizState,
  getStoredQuizState,
  persistQuizStateToWindow,
} from "../utils/quizState";

const QuizContext = createContext();

export const QuizProvider = ({ children }) => {
  const [quizState, setQuizState] = useState(getStoredQuizState);

  const saveQuizState = (newState) => {
    console.log("Saving quiz state:", newState);
    setQuizState((prev) => {
      const next = { ...prev, ...newState };
      persistQuizStateToWindow(next);
      return next;
    });
  };

  const resetQuizState = () => {
    const next = createDefaultQuizState();
    clearQuizStateFromWindow();
    setQuizState(next);
  };

  return (
    <QuizContext.Provider value={{ quizState, saveQuizState, resetQuizState }}>
      {children}
    </QuizContext.Provider>
  );
};

export const useQuiz = () => useContext(QuizContext);
